import { render } from "./XFooter.vue?vue&type=template&id=7e321c3d&scoped=true"
import script from "./XFooter.vue?vue&type=script&lang=js"
export * from "./XFooter.vue?vue&type=script&lang=js"

import "./XFooter.vue?vue&type=style&index=0&id=7e321c3d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e321c3d"]])

export default __exports__